/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KoreaReturnOrderCreateItemVo
 */
export interface KoreaReturnOrderCreateItemVo {
    /**
     * 来源商品ID，合包使用父商品ID
     * @type {number}
     * @memberof KoreaReturnOrderCreateItemVo
     */
    goodsId?: number;
    /**
     * 返送数量，合包按套数，单品按剩余数量限制
     * @type {number}
     * @memberof KoreaReturnOrderCreateItemVo
     */
    quantity?: number;
    /**
     * 本组合或单品的韩国快递单号，允许不填写
     * @type {string}
     * @memberof KoreaReturnOrderCreateItemVo
     */
    trackingNumber?: string;
}

/**
 * Check if a given object implements the KoreaReturnOrderCreateItemVo interface.
 */
export function instanceOfKoreaReturnOrderCreateItemVo(value: object): value is KoreaReturnOrderCreateItemVo {
    return true;
}

export function KoreaReturnOrderCreateItemVoFromJSON(json: any): KoreaReturnOrderCreateItemVo {
    return KoreaReturnOrderCreateItemVoFromJSONTyped(json, false);
}

export function KoreaReturnOrderCreateItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaReturnOrderCreateItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
    };
}

export function KoreaReturnOrderCreateItemVoToJSON(json: any): KoreaReturnOrderCreateItemVo {
    return KoreaReturnOrderCreateItemVoToJSONTyped(json, false);
}

export function KoreaReturnOrderCreateItemVoToJSONTyped(value?: KoreaReturnOrderCreateItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'quantity': value['quantity'],
        'trackingNumber': value['trackingNumber'],
    };
}

